'use strict';

// import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';

import { layer } from './plugins/layer/index.js';

import Lenis from 'lenis';

// import 'slick-carousel/slick/slick.css';

// import { checkAutoplaySupport } from './utiles/index.js'

// import LazyLoad from 'vanilla-lazyload';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// import * as CookieConsent from 'vanilla-cookieconsent';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';

import JustValidate from 'just-validate';

import EmblaCarousel from 'embla-carousel';
import EmblaAutoplay from 'embla-carousel-autoplay';
import EmblaAutoScroll from 'embla-carousel-auto-scroll';
import EmblaClassNames from 'embla-carousel-class-names';
import EmblaFade from 'embla-carousel-fade';
import EmblaAutoHeight from 'embla-carousel-auto-height';
import { addEmblaPrevNextClickHandlers } from './plugins/EmblaCarouselFeatures.js';

import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.js';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import axios from 'axios';

// import * as THREE from 'three';

// import Masonry from 'masonry-layout';

import { gsap } from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin(ScrollTrigger);
import SplitText from 'gsap/SplitText.js';
import CustomEase from 'gsap/CustomEase.js';
gsap.registerPlugin(SplitText);
gsap.registerPlugin(CustomEase);

import './iconfont/iconfont.js';

import Language from './language.js';
const lang = new Language();

// Initialize Lenis
const lenis = new Lenis();

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

document.addEventListener('DOMContentLoaded', () => {
	const headerMenuBtn = document.querySelector('.js-menu-btn');
	headerMenuBtn.addEventListener('click', () => {
		if (document.body.classList.contains('menu-open')) {
			document.body.classList.remove('menu-open');
			lenis.start();
		} else {
			document.body.classList.add('menu-open');
			lenis.stop();
		}
	});

	const dropMenuSubLinks = document.querySelectorAll('.hdms-link');
	dropMenuSubLinks.forEach((link) => {
		link.addEventListener('click', () => {
			document.body.classList.remove('menu-open');
			lenis.start();
		});
	});

	// logo Animattion
	const tl = gsap.timeline({ paused: true });

	if (document.querySelector('.header-logo-gz')) {
		tl.to('.header-logo-gz', { opacity: 0, duration: 0.2, ease: 'expo' });
	}
	tl.addLabel('step1');
	tl.to('.logo-path-2', { xPercent: -130, duration: 0.3, opacity: 0, ease: 'expo.inOut' }, 'step1');
	tl.to('.logo-path-3', { xPercent: -215, duration: 0.3, opacity: 0, ease: 'expo.inOut' }, 'step1');
	tl.to('.logo-path-4', { xPercent: -315, duration: 0.3, opacity: 0, ease: 'expo.inOut' }, 'step1');
	tl.to('.logo-path-5', { xPercent: -415, duration: 0.3, opacity: 0, ease: 'expo.inOut' }, 'step1');
	tl.to('.logo-path-6', { xPercent: -625, duration: 0.3, ease: 'expo.inOut' }, 'step1');

	const logo = document.querySelector('.header-logo');
	const tl2 = gsap.timeline({ paused: true });
	tl2.addLabel('step1');
	tl2.fromTo('.logo-path-7', { attr: { r: 0 } }, { attr: { r: 2.512 }, duration: 0.3, immediateRender: false }, 'step1');
	tl2.fromTo('.logo-path-8', { attr: { r: 0 } }, { attr: { r: 2.512 }, duration: 0.3, immediateRender: false }, 'step1+=.3');
	tl2.fromTo('.logo-clip-rect', { attr: { y: 36, height: 0 } }, { attr: { y: 0, height: 36 }, duration: 0.5, immediateRender: false }, 'step1+=.1');
	logo.addEventListener('mouseenter', () => {
		// gsap.set('.logo-clip-rect', { attr: { y: 36, height: 0 } });
		gsap.set('.logo-path-7, .logo-path-8', { attr: { r: 0 } });
		tl2.restart();
	});

	let isFixed = false;
	lenis.on('scroll', ({ animatedScroll }) => {
		// console.log(e);
		document.body.classList.toggle('fixed-menu', animatedScroll > 10);
		if (animatedScroll > 10) {
			if (!isFixed) {
				tl.play();
			}
			isFixed = true;
		} else {
			if (isFixed) {
				tl.reverse();
			}
			isFixed = false;
		}
	});

	if (document.querySelector('.page-index')) {
		const indexBanner = document.querySelector('.index-banner');
		lenis.on('scroll', ({ animatedScroll }) => {
			const h = indexBanner.offsetTop + indexBanner.offsetHeight;
			if (animatedScroll < h) {
				document.body.classList.add('black-menu');
			} else {
				document.body.classList.remove('black-menu');
			}
		});
	}

	const currentHour = new Date().getHours();
	console.log(sessionStorage.getItem('darkMode'), 'mode');
	console.log(currentHour, 'hour', currentHour < 17 && currentHour > 6 ? 'light' : 'dark');
	// sessionStorage.setItem('darkMode', currentHour < 17 && currentHour > 6 ? 'light' : 'dark');

	const currentMode = sessionStorage.getItem('darkMode');
	if (currentMode) {
		if (currentMode == 'dark') {
			document.documentElement.classList.add('dark');
		} else {
			document.documentElement.classList.remove('dark');
		}
	} else {
		if (currentHour < 19 && currentHour > 6) {
			document.documentElement.classList.remove('dark');
			sessionStorage.setItem('darkMode', 'light');
		} else {
			document.documentElement.classList.add('dark');
			sessionStorage.setItem('darkMode', 'dark');
		}
	}

	// light dark 图片切换
	const modeImgs = document.querySelectorAll('.js-lightdark-img');
	const updateModeImg = () => {
		const isDarkMode = document.documentElement.classList.contains('dark');
		modeImgs.forEach((img) => {
			img.setAttribute('src', isDarkMode ? img.getAttribute('data-dark') : img.getAttribute('data-light'));
		});
	};
	updateModeImg();

	const scrollEvent = new Event('scroll');
	// 触发 window 上的 scroll 事件
	window.dispatchEvent(scrollEvent);

	document.querySelectorAll('.js-header-mode').forEach((btn) => {
		btn.addEventListener('click', () => {
			if (document.documentElement.classList.contains('dark')) {
				document.documentElement.classList.remove('dark');
				document.body.classList.remove('menu-open');
				sessionStorage.setItem('darkMode', 'light');
				lenis.start();
			} else {
				document.documentElement.classList.add('dark');
				document.body.classList.remove('menu-open');
				sessionStorage.setItem('darkMode', 'dark');
				lenis.start();
			}

			updateModeImg();
			// 触发 window 上的 scroll 事件
			window.dispatchEvent(scrollEvent);
		});
	});

	// Index
	const indexSplitTextNode = document.querySelector('.js-split-text');
	if (indexSplitTextNode) {
		const tlb = gsap.timeline({ paused: true });
		tlb.addLabel('step1');
		tlb.to('.index-svg-a', { attr: { r: 26.8, duration: 0.3 } }, 'step1');
		tlb.to('.index-svg-b', { attr: { r: 26.8, duration: 0.3 } }, 'step1+=.3');
		tlb.to('.index-svg-clip', { attr: { y: 0, height: 400 }, duration: 0.5, ease: CustomEase.create('custom', 'M0,0 C0.126,0.382 0.142,1.099 0.577,0.83 0.99,0.572 0.818,1.001 1,1 ') }, 'step1+=.1');

		let split = SplitText.create(indexSplitTextNode, { type: 'chars' });
		gsap.from(split.chars, {
			yPercent: 50,
			autoAlpha: 0,
			stagger: 0.05,
			onComplete() {
				tlb.play();
			},
		});
	}

	const gotop = document.querySelector('.js-gotop');
	if (gotop) {
		gotop.addEventListener('click', () => {
			lenis.scrollTo(0);
		});
	}

	const commLogo = document.querySelectorAll('.comm-logo');
	if (commLogo.length) {
		commLogo.forEach((logo) => {
			const tl3 = gsap.timeline({ paused: true });
			tl3.addLabel('step1');
			tl3.fromTo(logo.querySelector('.comm-logo-a'), { attr: { r: 0 } }, { attr: { r: 2.512 }, duration: 0.3, immediateRender: false }, 'step1');
			tl3.fromTo(logo.querySelector('.comm-logo-b'), { attr: { r: 0 } }, { attr: { r: 2.512 }, duration: 0.3, immediateRender: false }, 'step1+=.3');
			tl3.fromTo(logo.querySelector('.comm-logo-clip'), { attr: { y: 36, height: 0 } }, { attr: { y: 0, height: 36 }, duration: 0.5, immediateRender: false }, 'step1+=.1');
			logo.addEventListener('mouseenter', () => {
				gsap.set(logo.querySelector('.comm-logo-clip'), { attr: { y: 36, height: 0 } });
				gsap.set(logo.querySelector('.comm-logo-a'), { attr: { r: 0 } });
				gsap.set(logo.querySelector('.comm-logo-b'), { attr: { r: 0 } });
				tl3.restart();
			});
		});
	}

	// About
	const emblaAbout = document.querySelector('.embla__viewport-about');
	if (emblaAbout) {
		const emblaApi = EmblaCarousel(emblaAbout, {}, [EmblaFade(), EmblaAutoHeight()]);
		const imgs = document.querySelectorAll('.js-about-img');
		const updateStatus = () => {
			const selectedIndex = emblaApi.selectedScrollSnap();
			imgs.forEach((img, i) => {
				img.classList.toggle('current', i === selectedIndex);
			});
		};
		emblaApi.on('select', updateStatus).on('init', updateStatus).on('reInit', updateStatus);

		imgs.forEach((img, index) => {
			img.addEventListener('click', () => {
				emblaApi.scrollTo(index);
			});
		});
	}

	const emblaAlogo = document.querySelector('.embla__viewport-alogo');
	if (emblaAlogo) {
		const autoplay = EmblaAutoplay({ playOnInit: true, stopOnFocusIn: true, delay: 3000 });
		const emblaApi = EmblaCarousel(emblaAlogo, { align: 'center', loop: true, containScroll: 'trimSnaps' }, [EmblaClassNames(), autoplay]);

		const slides = emblaApi.slideNodes();
		const len = slides.length;
		const updateWidths = () => {
			const centerIndex = emblaApi.selectedScrollSnap();
			// console.log(centerIndex, 'index');
			slides.forEach((slide, index) => {
				slide.classList.remove('slide-current', 'is-prev', 'is-next', 'is-prev-2', 'is-next-2');

				if (centerIndex - index === 0) {
					slide.classList.add('slide-current');
				} else if ((centerIndex - 1 + len) % len === index) {
					slide.classList.add('is-prev');
				} else if ((centerIndex + 1) % len === index) {
					slide.classList.add('is-next');
				} else if ((centerIndex - 2 + len) % len === index) {
					slide.classList.add('is-prev-2');
				} else if ((centerIndex + 2) % len === index) {
					slide.classList.add('is-next-2');
				}
			});
		};
		emblaApi.on('select', updateWidths).on('init', updateWidths);

		const prevBtn = document.querySelector('.alogo-prev');
		const nextBtn = document.querySelector('.alogo-next');
		prevBtn.addEventListener('click', () => {
			autoplay.reset();
		});
		nextBtn.addEventListener('click', () => {
			autoplay.reset();
		});
		addEmblaPrevNextClickHandlers(emblaApi, prevBtn, nextBtn);
	}

	const secMoreBtns = document.querySelectorAll('.js-sec-more');
	if (secMoreBtns.length) {
		secMoreBtns.forEach((btn) => {
			const box = btn.closest('.sec-box');
			btn.addEventListener('click', () => {
				box.classList.toggle('show');
			});
		});
	}

	// Join Us Form
	const contactFormNode = document.getElementById('contactForm');
	if (contactFormNode) {
		const validate = new JustValidate(contactFormNode);
		const postURL = contactFormNode.getAttribute('action');
		const btnSubmit = contactFormNode.querySelector('button[type="submit"]');
		validate
			.addField('.cform__name', [{ rule: 'required', errorMessage: lang.fillName }])
			.addField('.cform__tel', [
				{ rule: 'required', errorMessage: lang.fillTel },
				{ rule: 'customRegexp', value: lang.regexpTel, errorMessage: lang.phoneErr },
			])
			.addField('.cform__email', [
				{ rule: 'required', errorMessage: lang.fillEmail },
				{ rule: 'email', errorMessage: lang.emailErr },
			])
			.addField('.cform__company', [{ rule: 'required', errorMessage: lang.fillCompany }])
			.addField('.cform__msg', [{ rule: 'required', errorMessage: lang.fillMsg }])
			.onSuccess((event) => {
				console.log('success');

				btnSubmit.setAttribute('disabled', true);

				const formData = new FormData(contactFormNode);
				const serializedData = new URLSearchParams(formData).toString();

				// console.log(serializedData);

				axios
					.post(postURL, serializedData, {
						headers: {
							'X-WP-Nonce': WP_NONCE,
						},
					})
					.then(function (res) {
						// console.log(res);
						if (res.status == '200') {
							layer.msg(res.data.msg);
							setTimeout(() => {
								contactFormNode.reset();
								btnSubmit.removeAttribute('disabled');
							}, 2000);
						} else {
							layer.msg(res.data.msg);
						}
					})
					.catch(function (err) {
						console.log(err);
					});
			});
	}

	// News Scrolling Loading
	const newsPaqination = document.querySelector('.js-news-pagination');
	if (newsPaqination) {
		const listNewsBox = document.querySelector('.js-news-list');
		let newsLoading = false;

		const loadMoreNews = () => {
			if (newsLoading) return;
			newsLoading = true;
			// console.log('loading more news');

			const nextPage = newsPaqination.querySelector('.page-next');
			if (nextPage) {
				const url = nextPage.getAttribute('href');
				axios
					.get(url)
					.then((res) => {
						const data = res.data;
						const parser = new DOMParser();
						const doc = parser.parseFromString(data, 'text/html');
						const newsList = doc.querySelector('.js-news-list').innerHTML;
						const pagination = doc.querySelector('.js-news-pagination').innerHTML;
						newsPaqination.innerHTML = pagination;
						// console.log(newsList);
						if (newsList) {
							listNewsBox.innerHTML += newsList;
						}
						// newsLoading = false;
					})
					.catch(() => {
						// 错误处理
					})
					.finally(() => {
						newsLoading = false;
					});
			}
		};

		lenis.on('scroll', ({ scroll, animatedScroll }) => {
			// console.log(e);
			// console.log(scroll);
			if (newsLoading) return;
			console.log(newsPaqination.offsetTop, window.innerHeight);
			if (scroll > newsPaqination.offsetTop - window.innerHeight) {
				// console.log('loading start');
				loadMoreNews();
			}
		});
	}

	// 测试用
	// const domLoop = document.querySelectorAll('[data-loop]');
	// if (domLoop) {
	// 	domLoop.forEach((item) => {
	// 		const len = item.getAttribute('data-loop');
	// 		const sourceItem = item.innerHTML;
	// 		for (let i = 0; i < len; i++) {
	// 			item.innerHTML += sourceItem;
	// 		}
	// 	});
	// }

	// Init
	(() => {
		// const myLazyLoad = new LazyLoad({
		// 	threshold: 800
		// });
		AOS.init({
			duration: 800,
			offset: 40,
			once: true,
		});

		Fancybox.bind('[data-fancybox]', {
			// Your custom options
		});

		// Social Share
		// const share = new SimpleShare({
		// 	url: '',
		// 	title: '',
		// 	content: '',
		// 	pic: ''
		// });
		// const shareLinks = document.querySelectorAll('[data-share]');
		// shareLinks.forEach(link => {
		// 	link.addEventListener('click', () => {
		// 		share.goShare(link.getAttribute('data-share'));
		// 	})
		// });
	})();
});
